/**
 * Where a click on the EVI logo goes in the Admin (Warren, 23 October 2026: "Clicking the EVI logo (Admin and driver
 * app) goes to the dashboard map, not 'Today'"). The dashboard map for everyone, whatever their post-login landing
 * (Today for the Super Admin, the sales and partner pages for those personas); a fleet admin keeps their fleets.
 */
export const BRAND_HOME_PATH = '/dashboard';
export const FLEET_ADMIN_BRAND_HOME_PATH = '/fleets';

export function brandHomePath(role: string | null | undefined): string {
  return role === 'fleet_admin' ? FLEET_ADMIN_BRAND_HOME_PATH : BRAND_HOME_PATH;
}
